import React from "react";
import PropTypes from "prop-types";
import {
  Alert,
  AlertTitle,
  Button,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { keyframes, alpha } from "@mui/material/styles";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const SuggestedItemNumber = ({
  onUpdateItemNumber,
  recommendedItemNumber,
  itemNumber,
  localized,
}) => {
  const theme = useTheme();

  if (!recommendedItemNumber || itemNumber === recommendedItemNumber) {
    return null;
  }

  return (
    <Alert
      icon={<ErrorOutlineIcon fontSize="inherit" />}
      severity="warning"
      sx={{
        mb: 2,
        animation: `${fadeIn} 0.3s ease-in-out`,
        "& .MuiAlert-message": { flex: 1 },
      }}
    >
      <Stack spacing={1}>
        <AlertTitle
          sx={{
            color: theme.palette.warning.dark,
            fontWeight: 600,
            fontSize: "1.6rem",
          }}
        >
          {localized.SuggestedItemNumber} {recommendedItemNumber}
        </AlertTitle>

        <Typography
          variant="body2"
          sx={{ color: theme.palette.warning.main, fontSize: "1.4rem" }}
        >
          {localized.SuggestedItemNumberErrorMsg}
        </Typography>

        <Button
          variant="outlined"
          size="small"
          onClick={() => onUpdateItemNumber(recommendedItemNumber)}
          sx={{
            alignSelf: "flex-end",
            textTransform: "none",
            borderColor: theme.palette.warning.dark,
            color: theme.palette.warning.dark,
            fontWeight: 600,
            fontSize: "1.4rem",

            "&:hover": {
              borderColor: theme.palette.warning.dark,
              backgroundColor: alpha(theme.palette.warning.dark, 0.08),
            },
          }}
          style={{ margin: 0 }}
        >
          Apply suggestion
        </Button>
      </Stack>
    </Alert>
  );
};

SuggestedItemNumber.propTypes = {
  onUpdateItemNumber: PropTypes.func,
  itemNumber: PropTypes.string,
  recommendedItemNumber: PropTypes.string,
  localized: PropTypes.object,
};

export default SuggestedItemNumber;
